import { useSelector, useDispatch } from "react-redux";
import { AppState } from "../../store/configureStore";
import { Icon, Menu } from "semantic-ui-react";
import { logout } from "../../actions/authentificationActions";
import { logoutUser } from "../../services/userService";
import { Link } from "react-router-dom";
//@ts-ignore
import userGuidePdf from "../../documents/Perun4V User Guide.pdf";
import "./UserAvatar.css";

export const UserAvatar = () => {
    const user = useSelector((state: AppState) => state.user);
    const userName = user.firstName + " " + user.lastName;
    const dispatch = useDispatch();

    const handleLogout = async () => {
        await logoutUser();
        dispatch(logout());
    };

    return (
        <Menu id={`menu-userAvatar-${userName}`} secondary className="user-avatar-container">
            <a id={`a-userAvatar-${userName}`} className="item" href={userGuidePdf} target="_blank" rel="noopener noreferrer">
                <Icon id={`icon-userAvatar-${userName}`} name="book" />
                User's manual
            </a>
            {(user.role === "Admin" || user.role === "SuperAdmin" || user.role === "TSOAdmin") && (
                <Menu.Item id={`menu-item-userAvatar-a-${userName}`} as={Link} to={"/Manage-Users"} icon="users" content="Manage users" />
            )}
            <Menu.Item id={`menu-item-userAvatar-b-${userName}`} as={Link} to="/Profile" icon="user" content={userName} />
            <Menu.Item id={`menu-item-userAvatar-c-${userName}`} icon="log out" content="Logout" onClick={handleLogout} />
        </Menu>
    );
};
